<template>
    <section class="margin-both-lg container container--medium">
        <div class="inner ">
            <h2 v-if="data.section_title" class="titler margin-bottom-lg">{{data.section_title}}</h2>
            <div v-if="data.links" class="links-list">
                <template v-for="({link, color}, k) in data.links">
                    <ColorLink :key="k" :link="link" :color="color.name" :outlined="color.name !=='red'"/>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import ColorLink from '@/components/elements/ColorLink'

export default {
    name: 'link-buttons',
    props: ['data'],
    computed:{
        
    },
    methods:{
        linkType(link){
            const home = window.WPVUE.home
            return link.includes(home) ? 'link' : 'external'
        }
    },
    components:{
        ColorLink
    },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-links_block{
    text-align: center;
    .titler{
        margin-top: 0;
    }
    .inner{
        max-width: 750px;
        margin-bottom: -25px;
        margin-left: auto;
        margin-right: auto;
    }
    .links-list{
        margin-right: -25px;
    }
    .fill-button{
        margin-bottom: 25px;
        margin-right: 25px;
    }
    @include mquery($phone){
        .inner{
            margin-bottom: -15px;
        }
        .links-list{
            margin-right: -15px;
        }
        .fill-button{
            margin-bottom: 15px;
            margin-right: 15px;
        }   
    }
}
</style>